import type { FC, PropsWithChildren } from "react";
import { useCustomQuery } from "../../utils/api/apiService";
import { ENDPOINTS } from "../../utils/api/endpoints";
import type { AppMetaData } from "../../types/meta-data/meta-data";
import type { OperatorData } from "../../types/operator/operator";
import { MetaDataContext } from "./metaDataContext";
import TomanAnimatedLogo from "../../components/TomanAnimatedLogo";
import type { BaseResponse } from "../../types/api";
import { COMMISSION_TEMPORARILY_DISABLED } from "../../constants/commission";

const MetaDataProvider: FC<PropsWithChildren> = ({ children }) => {
  const { data: metaData } = useCustomQuery<BaseResponse<AppMetaData>>(
    ENDPOINTS.content.appMetaData,
  );

  const { data: operatorsData } = useCustomQuery<BaseResponse<OperatorData[]>>(
    ENDPOINTS.operators.base,
  );

  const operators = operatorsData?.data || [];

  if (!metaData?.data || !operatorsData?.data) {
    return <TomanAnimatedLogo />;
  }

  const qrPaymentCommissionOriginalAmount = metaData.data.qr_payment_commission_amount ?? 0;
  const qrPaymentCommissionAmount =
    metaData.data.qr_payment_commission_enabled === false || COMMISSION_TEMPORARILY_DISABLED
      ? 0
      : qrPaymentCommissionOriginalAmount;

  return (
    <MetaDataContext.Provider
      value={{
        metaData: metaData.data,
        operators,
        qrPaymentCommissionAmount,
        qrPaymentCommissionOriginalAmount,
      }}
    >
      {children}
    </MetaDataContext.Provider>
  );
};

export default MetaDataProvider;
